// import React, { useContext, useEffect, useState } from "react";

// import { DateRangePicker, createStaticRanges } from "react-date-range"; // FOR DATEPICKER

// import moment from "moment";

// import { format, differenceInDays } from "date-fns";

// import "react-date-range/dist/styles.css"; // main style file
// import "react-date-range/dist/theme/default.css"; // theme css file

// import Wrapper from "../helpers/Wrapper";

// import CalendarIcon from "../../assets/icons/CalendarIcon";
// import Button from "./Button";

// import {
//   setStartDate,
//   setEndDate,
//   setPrevStartDate,
//   setPrevEndDate,
//   setSecondPrevStartDate,
//   setSecondPrevEndDate,
// } from "../../store/dateSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { IAEvent_Datepicker_Visit } from "../../utils/IAEvents";
// import ErrorBoundary from "../../utils/ErrorBoundary";
// import DataUnavailableModal from "./DataUnavailableModal";
// import DataUnavailableHeader from "./DataUnavailableHeader";
// import DatepickerAlertContext from "../../store/datepickerAlertContext";
// import EventTracker from "../eventsTracking/EventTracker";
// import ConfirmationModal from "../ui/alert/ConfirmationModal"; // Import the ConfirmationModal component
// import { useLocation } from "react-router-dom";
// import useFetch from "../../hooks/useFetch"; // If not already imported

// export function formatDateDisplay(date, defaultText) {
//   if (!date) return defaultText;
//   return format(date, "yyyy-MM-dd");
// }

// function DatePicker(props) {
//   let minDateArr = [];
//   let maxDateArr = [];
//   const dispatch = useDispatch();
//   const { showDataUnavailableModal, setShowDataUnavailableModal, showDataUnavailableHeader, setShowDataUnavailableHeader, selectedDatesObj, setSelectedDatesObj, showDataUnavailableBrands, setShowDataUnavailableBrands } = useContext(DatepickerAlertContext)


//   // USER DATA
//   const userData = useSelector((state) => state.userData.user[0]);


//   const selectedDates = useSelector((state) => state.date);


//   // FOR SETTING THE END DATE OF CURRENT
//   let current_end_date = new Date();
//   current_end_date.setDate(current_end_date.getDate() - 6);

//   // FOR SETTING THE START DATE OF PREVIOUS
//   let previous_start_date = new Date();
//   previous_start_date.setDate(previous_start_date.getDate() - 13);

//   // FOR SETTING THE END DATE OF PREVIOUS
//   let previous_end_date = new Date();
//   previous_end_date.setDate(previous_end_date.getDate() - 7);


//   let second_previous_start_date = new Date();
//   second_previous_start_date.setDate(second_previous_start_date.getDate() - 20);

//   let second_previous_end_date = new Date();
//   second_previous_end_date.setDate(second_previous_end_date.getDate() - 14);

//   const [state, setState] = useState({
//     selection: {
//       startDate: selectedDates.startDate === "" ? current_end_date : new Date(selectedDates.startDate),
//       endDate: selectedDates.endDate === "" ? new Date() : new Date(selectedDates.endDate),
//       key: "selection",
//     },
//     compare: {
//       startDate: selectedDates.prevStartDate === "" ? previous_start_date : new Date(selectedDates.prevStartDate),
//       endDate: selectedDates.prevEndDate === "" ? previous_end_date : new Date(selectedDates.prevEndDate),
//       key: "compare",
//     },
//     secondCompare: {
//       startDate: selectedDates.secondPrevStartDate === "" ? second_previous_start_date : new Date(selectedDates.secondPrevStartDate),
//       endDate: selectedDates.secondPrevEndDate === "" ? second_previous_end_date : new Date(selectedDates.secondPrevEndDate),
//     }
//   });

// const [errorModalOpen, setErrorModalOpen] = useState(false);
// const [errorModalMsg, setErrorModalMsg] = useState("");
// const { post } = useFetch();
// const location = useLocation();

// const applyClickHandler = async (state) => {
//   // Build payload for validation API
//   const payload = {
//     global_filter: {
//       date_filter: {
//         mat_ty_start_date: formatDateDisplay(state.selection.startDate),
//         mat_ty_end_date: formatDateDisplay(state.selection.endDate),
//         mat_ly_start_date: formatDateDisplay(state.compare.startDate),
//         mat_ly_end_date: formatDateDisplay(state.compare.endDate),
//         mat_2y_start_date: formatDateDisplay(state.secondCompare.startDate),
//         mat_2y_end_date: formatDateDisplay(state.secondCompare.endDate),
//       },
//       filter: {}, // Add filter if needed
//     }
//   };

//   // Use correct endpoint based on route
//   const endpoint = location.pathname.includes("cross_source")
//     ? "ri/cross-source-data-validate"
//     : "ri/data-validate";

//   try {
//     const response = await post(endpoint, payload);
//     if (response?.valid) {
//       props.setOpen(!props.open);

//       dispatch(setStartDate(formatDateDisplay(state.selection.startDate)));
//       dispatch(setEndDate(formatDateDisplay(state.selection.endDate)));
//       dispatch(setPrevStartDate(formatDateDisplay(state.compare.startDate)));
//       dispatch(setPrevEndDate(formatDateDisplay(state.compare.endDate)));
//       dispatch(setSecondPrevStartDate(formatDateDisplay(state.secondCompare.startDate)));
//       dispatch(setSecondPrevEndDate(formatDateDisplay(state.secondCompare.endDate)));

//       IAEvent_Datepicker_Visit(
//         formatDateDisplay(state.selection.startDate),
//         formatDateDisplay(state.selection.endDate),
//         formatDateDisplay(state.compare.startDate),
//         formatDateDisplay(state.compare.endDate),
//       );

//       EventTracker({
//         eventType: "date_selected",
//         date: {
//           startDate: formatDateDisplay(state.selection.startDate),
//           endDate: formatDateDisplay(state.selection.endDate),
//           previousStartDate: formatDateDisplay(state.compare.startDate),
//           previousEndDate: formatDateDisplay(state.compare.endDate),
//         }
//       });
//     } else {
//       setErrorModalMsg(response?.message || "Data is not available for the selected combination of dates.");
//       setErrorModalOpen(true);
//     }
//   } catch (e) {
//     setErrorModalMsg("Something went wrong. Please try again.");
//     setErrorModalOpen(true);
//   }
// };

//   const staticRanges = createStaticRanges([
//     {
//       label: "Today",
//       range: () => ({
//         startDate: moment().startOf("day").toDate(),
//         endDate: moment().endOf("day").toDate(),
//         fromStaticRange: true,
//         identifier: "Today"
//       }),
//     },
//     {
//       label: "Yesterday",
//       range: () => ({
//         startDate: moment().subtract(1, "days").startOf("day").toDate(),
//         endDate: moment().subtract(1, "days").endOf("day").toDate(),
//         fromStaticRange: true,
//         identifier: "Yesterday"
//       }),
//     },
//     {
//       label: "This Week",
//       range: () => ({
//         startDate: moment().startOf("week").toDate(),
//         endDate: moment().endOf("week").toDate(),
//         fromStaticRange: true,
//         identifier: "thisWeek"
//       }),
//     },
//     {
//       label: "This Month",
//       range: () => ({
//         startDate: moment().startOf("month").toDate(),
//         endDate: moment().endOf("day").toDate(),
//         fromStaticRange: true,
//         identifier: "thisMonth"
//       }),
//     },
//     {
//       label: "Last Week",
//       range: () => ({
//         startDate: moment().subtract(1, "weeks").startOf("week").toDate(),
//         endDate: moment().subtract(1, "weeks").endOf("week").toDate(),
//         fromStaticRange: true,
//         identifier: "lastWeek"
//       }),
//     },
//     {
//       label: "Last 7 Days",
//       range: () => ({
//         startDate: moment().subtract(7, "days").startOf("day").toDate(),
//         endDate: moment().subtract(1, "days").endOf("day").toDate(),
//         fromStaticRange: true,
//         identifier: "last7Days"
//       }),
//     },
//     {
//       label: "Last 28 Days",
//       range: () => ({
//         startDate: moment().subtract(28, "days").startOf("day").toDate(),
//         endDate: moment().subtract(1, "days").endOf("day").toDate(),
//       }),
//     },
//     {
//       label: "Last 30 Days",
//       range: () => ({
//         startDate: moment().subtract(30, "days").startOf("day").toDate(),
//         endDate: moment().subtract(1, "days").endOf("day").toDate(),
//       }),
//     },
//     {
//       label: "Last 90 Days",
//       range: () => ({
//         startDate: moment().subtract(90, "days").startOf("day").toDate(),
//         endDate: moment().subtract(1, "days").endOf("day").toDate(),
//       }),
//     },
//     {
//       label: "Last 12 Months",
//       range: () => ({
//         startDate: moment().subtract(12, "months").startOf("month").toDate(),
//         endDate: moment().subtract(1, "months").endOf("month").toDate(),
//         fromStaticRange: true,
//         identifier: "last12Months"
//       }),
//     },
//     {
//       label: "Last Calendar Year",
//       range: () => ({
//         startDate: moment().subtract(1, "years").startOf("year").toDate(),
//         endDate: moment().subtract(1, "years").endOf("year").toDate(),
//         fromStaticRange: true,
//         identifier: "lastCalenderYear"
//       }),
//     },
//     {
//       label: "This Year (Jan - Today)",
//       range: () => ({
//         startDate: moment().startOf("year").toDate(),
//         endDate: moment().endOf("day").toDate(),
//         fromStaticRange: true,
//         identifier: "thisYear"
//       }),
//     },
//   ]);

//   const HandleChangeDateRange = (item) => {
//     // Helper function to calculate previous ranges
//     const calculatePreviousRanges = (selectionStart, selectionEnd) => {
//       const diffDays = differenceInDays(selectionEnd, selectionStart) + 1;

//       // Calculate compare range (previous period)
//       const compareEnd = new Date(selectionStart);
//       compareEnd.setDate(compareEnd.getDate() - 1);
//       const compareStart = new Date(compareEnd);
//       compareStart.setDate(compareStart.getDate() - diffDays + 1);

//       // Calculate second compare range (period before compare)
//       const secondCompareEnd = new Date(compareStart);
//       secondCompareEnd.setDate(secondCompareEnd.getDate() - 1);
//       const secondCompareStart = new Date(secondCompareEnd);
//       secondCompareStart.setDate(secondCompareStart.getDate() - diffDays + 1);

//       return {
//         compareStart,
//         compareEnd,
//         secondCompareStart,
//         secondCompareEnd
//       };
//     };

//     // Handle static ranges
//     if (item.selection?.fromStaticRange || item.compare?.fromStaticRange || item.range1?.fromStaticRange) {
//       const itemChild = item.selection || item.compare || item.range1;

//       let selectionStart, selectionEnd;

//       switch (itemChild.identifier) {
//         case "Today":
//           selectionStart = moment().startOf('day').toDate();
//           selectionEnd = moment().endOf('day').toDate();
//           break;
//         case "Yesterday":
//           selectionStart = moment().subtract(1, 'days').startOf('day').toDate();
//           selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
//           break;
//         case "thisWeek":
//           selectionStart = moment().startOf('week').toDate();
//           selectionEnd = moment().endOf('week').toDate();
//           break;
//         case "thisMonth":
//           selectionStart = moment().startOf('month').toDate();
//           selectionEnd = moment().endOf('day').toDate();
//           break;
//         case "lastWeek":
//           selectionStart = moment().subtract(1, 'weeks').startOf('week').toDate();
//           selectionEnd = moment().subtract(1, 'weeks').endOf('week').toDate();
//           break;
//         case "last7Days":
//           selectionStart = moment().subtract(7, 'days').startOf('day').toDate();
//           selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
//           break;
//         case "last28Days":
//           selectionStart = moment().subtract(28, 'days').startOf('day').toDate();
//           selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
//           break;
//         case "last30Days":
//           selectionStart = moment().subtract(30, 'days').startOf('day').toDate();
//           selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
//           break;
//         case "last90Days":
//           selectionStart = moment().subtract(90, 'days').startOf('day').toDate();
//           selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
//           break;
//         case "last12Months":
//           selectionStart = moment().subtract(12, 'months').startOf('month').toDate();
//           selectionEnd = moment().subtract(1, 'months').endOf('month').toDate();
//           break;
//         case "lastCalenderYear":
//           selectionStart = moment().subtract(1, 'years').startOf('year').toDate();
//           selectionEnd = moment().subtract(1, 'years').endOf('year').toDate();
//           break;
//         case "thisYear":
//           selectionStart = moment().startOf('year').toDate();
//           selectionEnd = moment().endOf('day').toDate();
//           break;
//         default:
//           // Default case for static ranges
//           setState(prev => ({
//             ...prev,
//             ...item,
//             compare: {
//               ...item.compare,
//               key: "compare"
//             },
//             secondCompare: {
//               ...item.secondCompare,
//               key: "secondCompare"
//             }
//           }));
//           return;
//       }

//       const { compareStart, compareEnd, secondCompareStart, secondCompareEnd } =
//         calculatePreviousRanges(selectionStart, selectionEnd);

//       setState({
//         selection: {
//           startDate: selectionStart,
//           endDate: selectionEnd,
//           key: "selection"
//         },
//         compare: {
//           startDate: compareStart,
//           endDate: compareEnd,
//           key: "compare"
//         },
//         secondCompare: {
//           startDate: secondCompareStart,
//           endDate: secondCompareEnd,
//           key: "secondCompare"
//         }
//       });
//     }
//     // Handle manual date selection
//     else if (item.selection) {
//       const { startDate, endDate } = item.selection;
//       const {
//         compareStart,
//         compareEnd,
//         secondCompareStart,
//         secondCompareEnd
//       } = calculatePreviousRanges(startDate, endDate);

//       setState(prev => ({
//         ...prev,
//         selection: {
//           ...item.selection,
//           startDate: startDate,
//           endDate: endDate
//         },
//         compare: {
//           startDate: compareStart,
//           endDate: compareEnd,
//           key: "compare"
//         },
//         secondCompare: {
//           startDate: secondCompareStart,
//           endDate: secondCompareEnd,
//           key: "secondCompare"
//         }
//       }));
//     }
//     // Handle compare range changes
//     else if (item.compare) {
//       const { startDate, endDate } = item.compare;
//       const diffDays = differenceInDays(endDate, startDate) + 1;

//       // Calculate second compare based on new compare range
//       const secondCompareEnd = new Date(startDate);
//       secondCompareEnd.setDate(secondCompareEnd.getDate() - 1);
//       const secondCompareStart = new Date(secondCompareEnd);
//       secondCompareStart.setDate(secondCompareStart.getDate() - diffDays + 1);

//       setState(prev => ({
//         ...prev,
//         compare: {
//           ...item.compare,
//           startDate: startDate,
//           endDate: endDate
//         },
//         secondCompare: {
//           startDate: secondCompareStart,
//           endDate: secondCompareEnd,
//           key: "secondCompare"
//         }
//       }));
//     }
//     // Handle second compare range changes
//     else if (item.secondCompare) {
//       setState(prev => ({
//         ...prev,
//         secondCompare: {
//           ...item.secondCompare,
//           key: "secondCompare"
//         }
//       }));
//     }
//   };

//   useEffect(() => {

//     try {
//       let getMinDateTime = new Date(Math.min(...minDateArr)).getTime();
//       let getMaxDateTime = new Date(Math.max(...maxDateArr)).getTime();
//       let getStartDateTime = new Date(selectedDates.startDate).getTime();
//       let getPrevStartDate = new Date(selectedDates.prevStartDate).getTime()
//       let getPrevEndDate = new Date(selectedDates.prevEndDate).getTime()

//       setSelectedDatesObj({
//         minDate: getMinDateTime,
//         maxDate: getMaxDateTime
//       })

//       if (
//         (getMinDateTime > getStartDateTime) || (getMaxDateTime < getStartDateTime) ||
//         ((getMinDateTime > getPrevStartDate) && (getMinDateTime > getPrevEndDate))
//       ) {
//         setShowDataUnavailableModal(true)
//       } else {
//         setShowDataUnavailableModal(false)
//         setShowDataUnavailableHeader(false)
//       }

//     } catch (error) {
//       console.error('Datepicker Error', error)
//       setShowDataUnavailableModal(false)
//       setShowDataUnavailableHeader(false)
//       setSelectedDatesObj({
//         minDate: new Date(),
//         maxDate: new Date('2000-01-01'),
//       })
//     }

//   }, [selectedDates])


//   return (
//     <Wrapper>
//       <ErrorBoundary chartType={'datepickerChartType'}>
//         <DataUnavailableModal
//           open={showDataUnavailableModal}
//           setOpen={setShowDataUnavailableModal}
//           setHeader={setShowDataUnavailableHeader}
//           handleDatepicker={props.setOpen}
//           minDate={new Date(Math.min(...minDateArr))}
//           maxDate={new Date(Math.max(...maxDateArr))}
//           brandList={showDataUnavailableBrands}
//         />
//         <DataUnavailableHeader show={showDataUnavailableHeader} dateValues={selectedDatesObj} setShowDataUnavailableHeader={setShowDataUnavailableHeader} brandList={showDataUnavailableBrands} />
//       </ErrorBoundary>
//       <div
//         onClick={() => props.setOpen(!props.open)}
//         className="datepicker_wrapper"
//       >
//         <div className="datepicker_section">
//           <div className="datepicker">
//             <div className="date_title">
//               {formatDateDisplay(state.selection.startDate)}
//             </div>
//             <div className="date_subtitle">to</div>
//             <div className="date_title">
//               {formatDateDisplay(state.selection.endDate)}
//             </div>
//           </div>
//           <CalendarIcon className="icon" />
//         </div>
//       </div>
//       {props.open && (
//         <div className="datepicker_dropdown_wrapper">
//           <DateRangePicker
//             className="datepicker_calender"
//             editableDateInputs={true}
//             onChange={(item) => HandleChangeDateRange(item)}
//             direction={"vertical"}
//             scroll={{ enabled: true }}
//             ranges={[state.selection, state.compare, state.secondCompare]}
//             color="#11a1fd"
//             rangeColors={["#11a1fd", "#FF9931", "#FED14C"]}
//             staticRanges={staticRanges}
//             minDate={minDateArr.length === 0 ? new Date('2000-01-01') : new Date(Math.min(...minDateArr))}
//             maxDate={maxDateArr.length === 0 ? new Date() : new Date(Math.max(...maxDateArr))}
//           // showDateDisplay={false} // Hide the date display
//           // monthDisplayFormat="MMM yyyy" // Format for month display
//           />
//           <div className="datepicker_footer">
//             <div className="btn_wrapper">
//               <Button handleClick={() => props.setOpen(!props.open)} className="secondary_danger_btn">
//                 Cancel
//               </Button>
//             </div>
//             <div className="btn_wrapper">
//               <Button handleClick={() => applyClickHandler(state)} className="primary_btn">
//                 Apply
//               </Button>
//             </div>
//           </div>
//           <ConfirmationModal
//   open={errorModalOpen}
//   onClose={() => setErrorModalOpen(false)}
//   type="error"
//   message={errorModalMsg}
//   title="Error"
// />
//         </div>
//       )}
//     </Wrapper>
//   );
// }
// export default DatePicker;

import React, { useContext, useEffect, useState,useRef,useCallback} from "react";

import { DateRangePicker, createStaticRanges } from "react-date-range"; // FOR DATEPICKER
import { flushSync } from 'react-dom'
import moment from "moment";

import { format, differenceInDays } from "date-fns";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import Wrapper from "../helpers/Wrapper";

import CalendarIcon from "../../assets/icons/CalendarIcon";
import Button from "./Button";

import {
  setStartDate,
  setEndDate,
  setPrevStartDate,
  setPrevEndDate,
  setSecondPrevStartDate,
  setSecondPrevEndDate,
} from "../../store/dateSlice";
import { useDispatch, useSelector } from "react-redux";
import { IAEvent_Datepicker_Visit } from "../../utils/IAEvents";
import ErrorBoundary from "../../utils/ErrorBoundary";
import DataUnavailableModal from "./DataUnavailableModal";
import DataUnavailableHeader from "./DataUnavailableHeader";
import DatepickerAlertContext from "../../store/datepickerAlertContext";
import EventTracker from "../eventsTracking/EventTracker";
import ConfirmationModal from "../ui/alert/ConfirmationModal"; // Import the ConfirmationModal component
import { useLocation } from "react-router-dom";
import useFetch from "../../hooks/useFetch"; // If not already imported

export function formatDateDisplay(date, defaultText) {
  if (!date) return defaultText;
  return format(date, "yyyy-MM-dd");
}

function DatePicker(props) {
  let minDateArr = [];
  let maxDateArr = [];
  const dispatch = useDispatch();
  const { showDataUnavailableModal, setShowDataUnavailableModal, showDataUnavailableHeader, setShowDataUnavailableHeader, selectedDatesObj, setSelectedDatesObj, showDataUnavailableBrands, setShowDataUnavailableBrands } = useContext(DatepickerAlertContext)


  // USER DATA
  const userData = useSelector((state) => state.userData.user[0]);


  const selectedDates = useSelector((state) => state.date);


  // FOR SETTING THE END DATE OF CURRENT
  let current_end_date = new Date();
  current_end_date.setDate(current_end_date.getDate() - 6);

  // FOR SETTING THE START DATE OF PREVIOUS
  let previous_start_date = new Date();
  previous_start_date.setDate(previous_start_date.getDate() - 13);

  // FOR SETTING THE END DATE OF PREVIOUS
  let previous_end_date = new Date();
  previous_end_date.setDate(previous_end_date.getDate() - 7);


  let second_previous_start_date = new Date();
  second_previous_start_date.setDate(second_previous_start_date.getDate() - 20);

  let second_previous_end_date = new Date();
  second_previous_end_date.setDate(second_previous_end_date.getDate() - 14);

  const [state, setState] = useState({
    selection: {
      startDate: selectedDates.startDate === "" ? current_end_date : new Date(selectedDates.startDate),
      endDate: selectedDates.endDate === "" ? new Date() : new Date(selectedDates.endDate),
      key: "selection",
    },
    compare: {
      startDate: selectedDates.prevStartDate === "" ? previous_start_date : new Date(selectedDates.prevStartDate),
      endDate: selectedDates.prevEndDate === "" ? previous_end_date : new Date(selectedDates.prevEndDate),
      key: "compare",
    },
    secondCompare: {
      startDate: selectedDates.secondPrevStartDate === "" ? second_previous_start_date : new Date(selectedDates.secondPrevStartDate),
      endDate: selectedDates.secondPrevEndDate === "" ? second_previous_end_date : new Date(selectedDates.secondPrevEndDate),
    }
  });

const [errorModalOpen, setErrorModalOpen] = useState(false);
const [errorModalMsg, setErrorModalMsg] = useState("");
const [isLoading, setIsLoading] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);
const abortControllerRef = useRef(null);

const { post } = useFetch();
const location = useLocation();

// const applyClickHandler = async (state) => {
//   // Build payload for validation API
//   const payload = {
//     global_filter: {
//       date_filter: {
//         mat_ty_start_date: formatDateDisplay(state.selection.startDate),
//         mat_ty_end_date: formatDateDisplay(state.selection.endDate),
//         mat_ly_start_date: formatDateDisplay(state.compare.startDate),
//         mat_ly_end_date: formatDateDisplay(state.compare.endDate),
//         mat_2y_start_date: formatDateDisplay(state.secondCompare.startDate),
//         mat_2y_end_date: formatDateDisplay(state.secondCompare.endDate),
//       },
//       filter: {}, // Add filter if needed
//     }
//   };

//   // Use correct endpoint based on route
//   const endpoint = location.pathname.includes("cross_source")
//     ? "ri/cross-source-data-validate"
//     : "ri/data-validate";

//   try {
//     const response = await post(endpoint, payload);
//     if (response?.valid) {
//       props.setOpen(!props.open);

//       dispatch(setStartDate(formatDateDisplay(state.selection.startDate)));
//       dispatch(setEndDate(formatDateDisplay(state.selection.endDate)));
//       dispatch(setPrevStartDate(formatDateDisplay(state.compare.startDate)));
//       dispatch(setPrevEndDate(formatDateDisplay(state.compare.endDate)));
//       dispatch(setSecondPrevStartDate(formatDateDisplay(state.secondCompare.startDate)));
//       dispatch(setSecondPrevEndDate(formatDateDisplay(state.secondCompare.endDate)));

//       IAEvent_Datepicker_Visit(
//         formatDateDisplay(state.selection.startDate),
//         formatDateDisplay(state.selection.endDate),
//         formatDateDisplay(state.compare.startDate),
//         formatDateDisplay(state.compare.endDate),
//       );

//       EventTracker({
//         eventType: "date_selected",
//         date: {
//           startDate: formatDateDisplay(state.selection.startDate),
//           endDate: formatDateDisplay(state.selection.endDate),
//           previousStartDate: formatDateDisplay(state.compare.startDate),
//           previousEndDate: formatDateDisplay(state.compare.endDate),
//         }
//       });
//     } else {
//       setErrorModalMsg(response?.message || "Data is not available for the selected combination of dates.");
//       setErrorModalOpen(true);
//     }
//   } catch (e) {
//     setErrorModalMsg("Something went wrong. Please try again.");
//     setErrorModalOpen(true);
//   }
// };
useEffect(() => {
  return () => {
    // Cleanup function to abort any pending requests when component unmounts
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
  };
}, []);
const submissionInProgress = useRef(false);

const applyClickHandler = useCallback(async (state) => {
    // Prevent multiple submissions using ref
    if (submissionInProgress.current) return;
    submissionInProgress.current = true;

    try {
        const payload = {
            global_filter: {
                date_filter: {
                    mat_ty_start_date: formatDateDisplay(state.selection.startDate),
                    mat_ty_end_date: formatDateDisplay(state.selection.endDate),
                    mat_ly_start_date: formatDateDisplay(state.compare.startDate),
                    mat_ly_end_date: formatDateDisplay(state.compare.endDate),
                    mat_2y_start_date: formatDateDisplay(state.secondCompare.startDate),
                    mat_2y_end_date: formatDateDisplay(state.secondCompare.endDate),
                },
                filter: {},
            }
        };

        const endpoint = location.pathname.includes("cross_source")
            ? "ri/cross-source-data-validate"
            : "ri/data-validate";

        const response = await post(endpoint, payload);

       if (response?.valid) {
    // Batch all updates in a synchronous operation
    flushSync(() => {
        // Close datepicker first
        props.setOpen(false);
        
        // Dispatch all date updates
        dispatch(setStartDate(formatDateDisplay(state.selection.startDate)));
        dispatch(setEndDate(formatDateDisplay(state.selection.endDate)));
        dispatch(setPrevStartDate(formatDateDisplay(state.compare.startDate)));
        dispatch(setPrevEndDate(formatDateDisplay(state.compare.endDate)));
        dispatch(setSecondPrevStartDate(formatDateDisplay(state.secondCompare.startDate)));
        dispatch(setSecondPrevEndDate(formatDateDisplay(state.secondCompare.endDate)));
    });

    // Events after state updates are complete
    IAEvent_Datepicker_Visit(
        formatDateDisplay(state.selection.startDate),
        formatDateDisplay(state.selection.endDate),
        formatDateDisplay(state.compare.startDate),
        formatDateDisplay(state.compare.endDate)
    );

    EventTracker({
        eventType: "date_selected",
        date: {
            startDate: formatDateDisplay(state.selection.startDate),
            endDate: formatDateDisplay(state.selection.endDate),
            previousStartDate: formatDateDisplay(state.compare.startDate),
            previousEndDate: formatDateDisplay(state.compare.endDate),
        }
    });
} else {
            setErrorModalMsg(response?.message || "Data is not available for the selected combination of dates.");
            setErrorModalOpen(true);
        }
    } catch (error) {
        console.error('Date validation error:', error);
        setErrorModalMsg("Something went wrong. Please try again.");
        setErrorModalOpen(true);
    } finally {
        submissionInProgress.current = false;
    }
}, [dispatch, post, props.setOpen]);


  const staticRanges = createStaticRanges([
    {
      label: "Today",
      range: () => ({
        startDate: moment().startOf("day").toDate(),
        endDate: moment().endOf("day").toDate(),
        fromStaticRange: true,
        identifier: "Today"
      }),
    },
    {
      label: "Yesterday",
      range: () => ({
        startDate: moment().subtract(1, "days").startOf("day").toDate(),
        endDate: moment().subtract(1, "days").endOf("day").toDate(),
        fromStaticRange: true,
        identifier: "Yesterday"
      }),
    },
    {
      label: "This Week",
      range: () => ({
        startDate: moment().startOf("week").toDate(),
        endDate: moment().endOf("week").toDate(),
        fromStaticRange: true,
        identifier: "thisWeek"
      }),
    },
    {
      label: "This Month",
      range: () => ({
        startDate: moment().startOf("month").toDate(),
        endDate: moment().endOf("day").toDate(),
        fromStaticRange: true,
        identifier: "thisMonth"
      }),
    },
    {
      label: "Last Week",
      range: () => ({
        startDate: moment().subtract(1, "weeks").startOf("week").toDate(),
        endDate: moment().subtract(1, "weeks").endOf("week").toDate(),
        fromStaticRange: true,
        identifier: "lastWeek"
      }),
    },
    {
      label: "Last 7 Days",
      range: () => ({
        startDate: moment().subtract(7, "days").startOf("day").toDate(),
        endDate: moment().subtract(1, "days").endOf("day").toDate(),
        fromStaticRange: true,
        identifier: "last7Days"
      }),
    },
    {
      label: "Last 28 Days",
      range: () => ({
        startDate: moment().subtract(28, "days").startOf("day").toDate(),
        endDate: moment().subtract(1, "days").endOf("day").toDate(),
      }),
    },
    {
      label: "Last 30 Days",
      range: () => ({
        startDate: moment().subtract(30, "days").startOf("day").toDate(),
        endDate: moment().subtract(1, "days").endOf("day").toDate(),
      }),
    },
    {
      label: "Last 90 Days",
      range: () => ({
        startDate: moment().subtract(90, "days").startOf("day").toDate(),
        endDate: moment().subtract(1, "days").endOf("day").toDate(),
      }),
    },
    {
      label: "Last 12 Months",
      range: () => ({
        startDate: moment().subtract(12, "months").startOf("month").toDate(),
        endDate: moment().subtract(1, "months").endOf("month").toDate(),
        fromStaticRange: true,
        identifier: "last12Months"
      }),
    },
    {
      label: "Last Calendar Year",
      range: () => ({
        startDate: moment().subtract(1, "years").startOf("year").toDate(),
        endDate: moment().subtract(1, "years").endOf("year").toDate(),
        fromStaticRange: true,
        identifier: "lastCalenderYear"
      }),
    },
    {
      label: "This Year (Jan - Today)",
      range: () => ({
        startDate: moment().startOf("year").toDate(),
        endDate: moment().endOf("day").toDate(),
        fromStaticRange: true,
        identifier: "thisYear"
      }),
    },
  ]);

  const HandleChangeDateRange = (item) => {
    // Helper function to calculate previous ranges
    const calculatePreviousRanges = (selectionStart, selectionEnd) => {
      const diffDays = differenceInDays(selectionEnd, selectionStart) + 1;

      // Calculate compare range (previous period)
      const compareEnd = new Date(selectionStart);
      compareEnd.setDate(compareEnd.getDate() - 1);
      const compareStart = new Date(compareEnd);
      compareStart.setDate(compareStart.getDate() - diffDays + 1);

      // Calculate second compare range (period before compare)
      const secondCompareEnd = new Date(compareStart);
      secondCompareEnd.setDate(secondCompareEnd.getDate() - 1);
      const secondCompareStart = new Date(secondCompareEnd);
      secondCompareStart.setDate(secondCompareStart.getDate() - diffDays + 1);

      return {
        compareStart,
        compareEnd,
        secondCompareStart,
        secondCompareEnd
      };
    };

    // Handle static ranges
    if (item.selection?.fromStaticRange || item.compare?.fromStaticRange || item.range1?.fromStaticRange) {
      const itemChild = item.selection || item.compare || item.range1;

      let selectionStart, selectionEnd;

      switch (itemChild.identifier) {
        case "Today":
          selectionStart = moment().startOf('day').toDate();
          selectionEnd = moment().endOf('day').toDate();
          break;
        case "Yesterday":
          selectionStart = moment().subtract(1, 'days').startOf('day').toDate();
          selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
          break;
        case "thisWeek":
          selectionStart = moment().startOf('week').toDate();
          selectionEnd = moment().endOf('week').toDate();
          break;
        case "thisMonth":
          selectionStart = moment().startOf('month').toDate();
          selectionEnd = moment().endOf('day').toDate();
          break;
        case "lastWeek":
          selectionStart = moment().subtract(1, 'weeks').startOf('week').toDate();
          selectionEnd = moment().subtract(1, 'weeks').endOf('week').toDate();
          break;
        case "last7Days":
          selectionStart = moment().subtract(7, 'days').startOf('day').toDate();
          selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
          break;
        case "last28Days":
          selectionStart = moment().subtract(28, 'days').startOf('day').toDate();
          selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
          break;
        case "last30Days":
          selectionStart = moment().subtract(30, 'days').startOf('day').toDate();
          selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
          break;
        case "last90Days":
          selectionStart = moment().subtract(90, 'days').startOf('day').toDate();
          selectionEnd = moment().subtract(1, 'days').endOf('day').toDate();
          break;
        case "last12Months":
          selectionStart = moment().subtract(12, 'months').startOf('month').toDate();
          selectionEnd = moment().subtract(1, 'months').endOf('month').toDate();
          break;
        case "lastCalenderYear":
          selectionStart = moment().subtract(1, 'years').startOf('year').toDate();
          selectionEnd = moment().subtract(1, 'years').endOf('year').toDate();
          break;
        case "thisYear":
          selectionStart = moment().startOf('year').toDate();
          selectionEnd = moment().endOf('day').toDate();
          break;
        default:
          // Default case for static ranges
          setState(prev => ({
            ...prev,
            ...item,
            compare: {
              ...item.compare,
              key: "compare"
            },
            secondCompare: {
              ...item.secondCompare,
              key: "secondCompare"
            }
          }));
          return;
      }

      const { compareStart, compareEnd, secondCompareStart, secondCompareEnd } =
        calculatePreviousRanges(selectionStart, selectionEnd);

      setState({
        selection: {
          startDate: selectionStart,
          endDate: selectionEnd,
          key: "selection"
        },
        compare: {
          startDate: compareStart,
          endDate: compareEnd,
          key: "compare"
        },
        secondCompare: {
          startDate: secondCompareStart,
          endDate: secondCompareEnd,
          key: "secondCompare"
        }
      });
    }
    // Handle manual date selection
    else if (item.selection) {
      const { startDate, endDate } = item.selection;
      const {
        compareStart,
        compareEnd,
        secondCompareStart,
        secondCompareEnd
      } = calculatePreviousRanges(startDate, endDate);

      setState(prev => ({
        ...prev,
        selection: {
          ...item.selection,
          startDate: startDate,
          endDate: endDate
        },
        compare: {
          startDate: compareStart,
          endDate: compareEnd,
          key: "compare"
        },
        secondCompare: {
          startDate: secondCompareStart,
          endDate: secondCompareEnd,
          key: "secondCompare"
        }
      }));
    }
    // Handle compare range changes
    else if (item.compare) {
      const { startDate, endDate } = item.compare;
      const diffDays = differenceInDays(endDate, startDate) + 1;

      // Calculate second compare based on new compare range
      const secondCompareEnd = new Date(startDate);
      secondCompareEnd.setDate(secondCompareEnd.getDate() - 1);
      const secondCompareStart = new Date(secondCompareEnd);
      secondCompareStart.setDate(secondCompareStart.getDate() - diffDays + 1);

      setState(prev => ({
        ...prev,
        compare: {
          ...item.compare,
          startDate: startDate,
          endDate: endDate
        },
        secondCompare: {
          startDate: secondCompareStart,
          endDate: secondCompareEnd,
          key: "secondCompare"
        }
      }));
    }
    // Handle second compare range changes
    else if (item.secondCompare) {
      setState(prev => ({
        ...prev,
        secondCompare: {
          ...item.secondCompare,
          key: "secondCompare"
        }
      }));
    }
  };
  useEffect(() => {
  let isSubscribed = true;

  // Cleanup function
  return () => {
    isSubscribed = false;
    // If you have an abort controller for your API calls
    // abortController.abort();
  };
}, []);

  useEffect(() => {

    try {
      let getMinDateTime = new Date(Math.min(...minDateArr)).getTime();
      let getMaxDateTime = new Date(Math.max(...maxDateArr)).getTime();
      let getStartDateTime = new Date(selectedDates.startDate).getTime();
      let getPrevStartDate = new Date(selectedDates.prevStartDate).getTime()
      let getPrevEndDate = new Date(selectedDates.prevEndDate).getTime()

      setSelectedDatesObj({
        minDate: getMinDateTime,
        maxDate: getMaxDateTime
      })

      if (
        (getMinDateTime > getStartDateTime) || (getMaxDateTime < getStartDateTime) ||
        ((getMinDateTime > getPrevStartDate) && (getMinDateTime > getPrevEndDate))
      ) {
        setShowDataUnavailableModal(true)
      } else {
        setShowDataUnavailableModal(false)
        setShowDataUnavailableHeader(false)
      }

    } catch (error) {
      console.error('Datepicker Error', error)
      setShowDataUnavailableModal(false)
      setShowDataUnavailableHeader(false)
      setSelectedDatesObj({
        minDate: new Date(),
        maxDate: new Date('2000-01-01'),
      })
    }

  }, [selectedDates])


  return (
    <Wrapper>
      <ErrorBoundary chartType={'datepickerChartType'}>
        <DataUnavailableModal
          open={showDataUnavailableModal}
          setOpen={setShowDataUnavailableModal}
          setHeader={setShowDataUnavailableHeader}
          handleDatepicker={props.setOpen}
          minDate={new Date(Math.min(...minDateArr))}
          maxDate={new Date(Math.max(...maxDateArr))}
          brandList={showDataUnavailableBrands}
        />
        <DataUnavailableHeader show={showDataUnavailableHeader} dateValues={selectedDatesObj} setShowDataUnavailableHeader={setShowDataUnavailableHeader} brandList={showDataUnavailableBrands} />
      </ErrorBoundary>
      <div
        onClick={() => props.setOpen(!props.open)}
        className="datepicker_wrapper"
      >
        <div className="datepicker_section">
          <div className="datepicker">
            <div className="date_title">
              {formatDateDisplay(state.selection.startDate)}
            </div>
            <div className="date_subtitle">to</div>
            <div className="date_title">
              {formatDateDisplay(state.selection.endDate)}
            </div>
          </div>
          <CalendarIcon className="icon" />
        </div>
      </div>
      {props.open && (
        <div className="datepicker_dropdown_wrapper">
          <DateRangePicker
            className="datepicker_calender"
            editableDateInputs={true}
            onChange={(item) => HandleChangeDateRange(item)}
            direction={"vertical"}
            scroll={{ enabled: true }}
            ranges={[state.selection, state.compare, state.secondCompare]}
            color="#11a1fd"
            rangeColors={["#11a1fd", "#FF9931", "#FED14C"]}
            staticRanges={staticRanges}
            minDate={minDateArr.length === 0 ? new Date('2000-01-01') : new Date(Math.min(...minDateArr))}
            maxDate={maxDateArr.length === 0 ? new Date() : new Date(Math.max(...maxDateArr))}
          // showDateDisplay={false} // Hide the date display
          // monthDisplayFormat="MMM yyyy" // Format for month display
          />
          <div className="datepicker_footer">
            <div className="btn_wrapper">
              <Button handleClick={() => props.setOpen(!props.open)} className="secondary_danger_btn">
                Cancel
              </Button>
            </div>
            <div className="btn_wrapper">
              {/* <Button handleClick={() => applyClickHandler(state)} className="primary_btn">
                Apply
              </Button> */}
        <Button 
    handleClick={() => {
        if (!submissionInProgress.current) {
            applyClickHandler(state);
        }
    }} 
    className="primary_btn"
    disabled={submissionInProgress.current}
>
    {submissionInProgress.current ? "Applying..." : "Apply"}
</Button>
            </div>
          </div>
          <ConfirmationModal
  open={errorModalOpen}
  onClose={() => setErrorModalOpen(false)}
  type="error"
  message={errorModalMsg}
  title="Error"
/>
        </div>
      )}
    </Wrapper>
  );
}
export default DatePicker;

